import { useBasketOrderOrderbookStoreBase } from './basketOrderBook.store';
import type { BasketOrderOrderbookStore } from './basketOrderBook.types';

// ===== Non Reactive Selectors (To be use with regular functions) (NON-REACTIVE) =====
// #region Non Reactive Selectors
const basketOrderOrderBookStoreSelector = () =>
  useBasketOrderOrderbookStoreBase.getState().state;

// #endregion Non Reactive Selectors

// ===== Reactive Selectors (To be use din React Components) (REACTIVE) =====
// #region Reactive Selectors
const selectBasketOrderbookBuySide = (store: BasketOrderOrderbookStore) =>
  store.state.buy;
const selectBasketOrderbookSellSide = (store: BasketOrderOrderbookStore) =>
  store.state.sell;

// #endregion Reactive Selectors

export {
  // #region Non Reactive Selectors
  basketOrderOrderBookStoreSelector,
  // #endregion

  // #region Reactive Selectors (use with useBasketOrderOrderbookStoreBase)
  selectBasketOrderbookBuySide,
  selectBasketOrderbookSellSide,
  // #endregion
};
